/// <reference path="../../app.definition.ts" />

import angular from "angular";
import { IUtilityService } from "@common/service/util.service";


function titleCase($_util: IUtilityService) {
    return function (input) {
        if (!!input) {
            return $_util.toTitleCase(input);
        }
        return null;
    }

}

angular.module('eCareVault.common.filters').filter('titleCase', ["UtilityService", titleCase]);
